<ng-container>
	<div class="icon iconPressure" [ngClass]="getIconState('pressure')"></div>
	<div class="icon iconContact" [ngClass]="getIconState('mobile')"></div> <!-- TODO: Icon austauschen -->
	<div class="icon iconLocked" [ngClass]="getIconState('locked')"></div>
	<div class="icon iconChimneySweep" [ngClass]="getIconState('chimneysweep')"></div>
	<div class="icon iconInstaller" [ngClass]="getIconState('installer')"></div>
	<div class="icon iconEcoMode" [ngClass]="getIconState('ecomode')"></div>
	<div class="icon iconAdjustTime" [ngClass]="getIconState('adjusttime')"></div><!-- TODO: Icon austauschen -->
</ng-container>
